import CircleIcon from 'components/CircleIcon';
import QuoteBookingComponentIcon from 'components/quoteBooking/QuoteBookingComponentIcon';
import SectionTitle from 'components/typography/SectionTitle';
import useWhiteLabelSettings from 'hooks/useWhiteLabelSettings';
import { COMPONENT_COACH } from 'shared/constants/common';
import CoachesItem from './CoachesItem';

export default function Coaches({ coachesList = [] }) {
  const { whiteLabelSettings: { primaryColour } = {} } =
    useWhiteLabelSettings();
  return (
    <>
      <div className="mt-[60px] lg:mt-[40px] flex items-start">
        <CircleIcon className="mt-1">
          <QuoteBookingComponentIcon
            componentType={COMPONENT_COACH}
            fillColor={primaryColour}
          />
        </CircleIcon>
        <SectionTitle label="Coaches" className="ml-[10px] mt-1" />
      </div>
      {coachesList.map((coach, index) => (
        <div key={`${index + 1}`} className="mt-[40px]">
          <CoachesItem coach={coach} />
        </div>
      ))}
    </>
  );
}
